import type { ModalStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const modal: ModalStyles = {
  modal: {
    '&.welcome': {
      '${max.lg}': {
        '.modal-content': {
          background: colors.white,
        },
      },
      '${min.lg}': {
        '.modal-lg, .modal-xl': {
          maxWidth: '900px',
        },
      },
    },
    '&.fade': {
      '.modal-dialog': {
        WebkitTransform: 'translate(0, 0)',
        transform: 'translate(0, 0)',
      },
    },
    '.modal-dialog': {
      '.modal-content': {
        borderRadius: '24px',
        border: 'none',

        '.modal-header': {
          borderBottom: 'none',

          '.close': {
            fontSize: '38px',
            fontWeight: fonts.fontWeights.light,
            background: colors.light,
            textShadow: 'none',
            padding: '2px 5px 0px 5px',
            borderRadius: '32px',
            marginTop: '10px',
            marginRight: '10px',
            color: colors.dark,
            lineHeight: '28px',

            span: {
              opacity: '0.7',
            },
          },
        },
        '.modal-body': {
          '.btn-primary': {
            margin: '0',
          },
        },
      },
    },
  },
};

export default modal;
